import React from 'react';
import { Box, CircularProgress, Icon, IconButton, Tooltip } from '@material-ui/core';
import { DateFormatter, FileManager } from 'components/AppTable/CellsComponents';
import i18next from 'i18next';

const incompleteLabel = () => i18next.t('trainingSessions.incomplete');

const formatEvidenceCell = (evidenceParams, helpers) => {
  if (!evidenceParams || typeof evidenceParams !== 'object') {
    return incompleteLabel();
  }

  const {
    hasCertificate,
    hasAssessmentResult,
    isPerformedWithSuccess,
    certificate,
    rowId,
    isMoodleCourse,
    allowUpload,
  } = evidenceParams;

  if (isPerformedWithSuccess === false) {
    return incompleteLabel();
  }

  const canLazyMoodleCertificate = Boolean(isMoodleCourse) && isPerformedWithSuccess === true;
  const showCertificateUpload = Boolean(allowUpload) && !hasCertificate && !canLazyMoodleCertificate;
  const showCertificateDownload = hasCertificate || canLazyMoodleCertificate;
  const showQuizAnswers = Boolean(hasAssessmentResult);
  const isCertificateDownloading = helpers.isDownloadingCertificate?.(rowId);
  const isAssessmentDownloading = helpers.isDownloadingAssessment?.(rowId);

  if (!showCertificateUpload && !showCertificateDownload && !showQuizAnswers) {
    return incompleteLabel();
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 4 }}>
      {showCertificateDownload || showCertificateUpload ? (
        <FileManager
          value={{
            id: rowId,
            certificate: hasCertificate ? certificate || {} : canLazyMoodleCertificate ? {} : null,
            isPerformedWithSuccess: isPerformedWithSuccess !== false,
            isMoodleCourse: Boolean(isMoodleCourse) && !allowUpload,
            isDownloading: Boolean(isCertificateDownloading),
          }}
          id={rowId}
          onChange={helpers.handleAddCertificate}
          onShowCertificate={helpers.handleShowCertificate}
        />
      ) : null}
      {showQuizAnswers ? (
        isAssessmentDownloading ? (
          <CircularProgress size={18} />
        ) : (
          <Tooltip title={i18next.t('trainingSessions.answersDownloadTooltip')} placement="top" arrow>
            <IconButton size="small" color="primary" onClick={() => helpers.handleDownloadQuizAnswers(rowId)}>
              <Icon fontSize="small">get_app</Icon>
            </IconButton>
          </Tooltip>
        )
      ) : null}
    </Box>
  );
};

export const getEvidenceHistoryConfig = helpers => [
  {
    title: i18next.t('tablesLabels.id'),
    field: 'id',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.trainingModule'),
    field: 'trainingModuleLabel',
  },
  {
    title: i18next.t('tablesLabels.trainingPart'),
    field: 'trainingPartLabel',
  },
  {
    title: i18next.t('tablesLabels.source'),
    field: 'sourceLabel',
  },
  {
    title: '',
    field: 'source',
    isVisible: false,
    hiddenHeader: true,
  },
  {
    title: '',
    field: 'canEditExternalEvidence',
    isVisible: false,
    hiddenHeader: true,
  },
  {
    title: '',
    field: 'canDeleteExternalEvidence',
    isVisible: false,
    hiddenHeader: true,
  },
  {
    title: i18next.t('tablesLabels.performedDate'),
    field: 'issuedAt',
    Component: value => <DateFormatter value={value} />,
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.expiryDate'),
    field: 'expiresAt',
    Component: value => <DateFormatter value={value} />,
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.status'),
    field: 'approvalStatus',
  },
  {
    title: i18next.t('trainingSessions.evidence'),
    field: 'evidenceParams',
    alignment: 'center',
    Component: value => formatEvidenceCell(value, helpers),
  },
  {
    title: i18next.t('tablesLabels.byWhom'),
    field: 'byWhom',
  },
];
